import { useContext, useState, } from 'react';
import { Box, Button, ButtonGroup, CircularProgress, Divider, Grid, IconButton, List, ListItem, ListItemSecondaryAction, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import { NameInput } from './NameInput';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { CreateTerm } from '../../graphqlCommunication/TermsInterface';
import wiki from 'wikipedia';
import clsx from 'clsx';
import parse from 'html-react-parser'
import akronim from "akronim";
import DeleteIcon from '@material-ui/icons/Delete';
import BlurOnIcon from '@material-ui/icons/BlurOn';

// Context
import AuthContext from '../../context/authContext';
import DataContext from '../../context/dataContext';
import { TooltipStyle } from '../basicComponents/HtmlTooltip';
import SnackBarSuccess from '../basicComponents/SnackBarSuccess';
import SnackBarError from '../basicComponents/SnackBarError';
import { SelectTermDomainSpace } from '../basicComponents/SelectTermDomainSpace';
import { CreateLink } from '../../graphqlCommunication/LinksInterface';

const OPENAI_API_KEY = process.env.REACT_APP_OPENAI_API_KEY;

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.myDivider.main,
        color: theme.palette.text,
        fontSize: "1rem",
    },
    body: {
        fontSize: "1rem",
    },
}))(TableCell);



const useStyles = makeStyles((theme) => ({
    container: {
        paddingTop: theme.spacing(8),
        paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(0),
        paddingBottom: theme.spacing(1),
        background: "lightgray",
        maxWidth: "none",
        overflow: "hidden",
        [theme.breakpoints.up("sm")]: {
            //height: '100vh',
            /*  border: "1px solid #999" */
        },
    },
    tabContext: {

    },
    appbar: {
        paddingTop: theme.spacing(0),
        background: "lightgray",
        color: theme.palette.text.primary,
    },
    tabPanel: {
        paddingTop: theme.spacing(0),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(1),
    },
    gridContainer: {
        padding: theme.spacing(0),
        height: '100%',
        overflow: 'auto', // Ermöglicht das Scrollen innerhalb des Containers
    },
    paper: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        //height: `calc(100% - ${theme.spacing(4)}px)`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto', // Ermöglicht das Scrollen innerhalb des Containers
    },
    paperList: {
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        //height: `calc(100% - ${theme.spacing(4)}px)`,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: 600,

        [theme.breakpoints.up("sm")]: {// Mobile
            height: '100%',
            maxHeight: 600,
        },
    },
    input: {
        minWidth: 160,
        maxWidth: 240,
    },
    inputWide: {
        minWidth: 160,
        maxWidth: 1200,
    },
    margin: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    text: {
        color: theme.palette.text.main,
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    infoText: {
        color: theme.palette.text.main,
        marginRight: theme.spacing(1),
    },
    topicText: {
        color: theme.palette.text.main,
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(0),
        marginTop: theme.spacing(1),
    },
    button: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    link: {
        textDecoration: 'none',
        color: theme.palette.text.main,
    },
    table: {
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        [theme.breakpoints.down("sm")]: {// Mobile
            display: "none",
        }
    },
    list: {
        height: `calc(90% - ${theme.spacing(8)}px)`,
        overflow: 'auto',
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
        [theme.breakpoints.up("md")]: {// Mobile
            display: "none",
        }
    },
    listItem: {
        alignItems: 'flex-start',
        //color: theme.palette.primary.light,
        /*  marginTop: theme.spacing(0),
         marginBottom: theme.spacing(0),
         paddingTop: theme.spacing(1),
         paddingBottom: theme.spacing(1), */
    },
    listTextItem: {
        //color: theme.palette.primary.light,
        marginLeft: theme.spacing(2),
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
    divider: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
        marginBottom: theme.spacing(2),
    },
    dividerTop: {
        marginTop: theme.spacing(2),
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
    },
    dividerBottom: {
        marginTop: theme.spacing(0),
        marginLeft: theme.spacing(-2),
        marginRight: theme.spacing(-2),
    },
    flexContainer: {
        display: 'flex',
        justifyContent: 'space-between', // Verteilt den verfügbaren Platz zwischen den Elementen
        alignItems: 'center',
    },
    
    buttonProgress: {
        color: 'green',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));


export const CreateDomain = ({ setTermArray, domainSpaceDefinition, termTypeMap, relatedTerms, setRelatedTerms }) => {
    const classes = useStyles();


    // Context
    const contextType = useContext(AuthContext);
    const dataContext = useContext(DataContext);
    const termArray = dataContext.termArray;
    const linkArray = dataContext.linkArray;
    const setLinkArray = dataContext.setLinkArray;
    //const setTermArray = dataContext.setTermArray;

    // States and Handler for the Edit Dialog
    const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
    //const [relatedTerms, setRelatedTerms] = useState({});
    const [openAlert, setOpenAlert] = useState(false)
    const [openEmptySearachAlert, setOpenEmptySearachAlert] = useState(false)
    const [openErrorAlert, setOpenErrorAlert] = useState(false)
    const [itemSelected, setItemSelected] = useState();
    const updateSelected = (index) => {
        setItemSelected(index)
    };

    const [loading, setLoading] = useState(false);


    const handleImagePreviewOpenClose = () => {
        setImagePreviewOpen(false);
    };

    const handlViewImage = () => {
        console.log(data)
        setImagePreviewOpen(true);
    }

    // Set Defalt Values
    const defaultType = termTypeMap.length > 0 ? termTypeMap[0].split(";")[0] : '';
    console.log("defaultType")
    console.log(defaultType)

    let domainSpaceDefinitionArray = []
    Object.keys(domainSpaceDefinition).map((dom) => {
        domainSpaceDefinitionArray = domainSpaceDefinitionArray.concat(dom);
    })
    const defaultDomain = domainSpaceDefinitionArray.length > 0 ? domainSpaceDefinitionArray[0] : '';

    console.log("domainSpaceDefinition")
    console.log(domainSpaceDefinition)

    const emptyForm = {
        name: '',
        description: '',
        descriptionHtml: '',
        abbreviation: '',
        type: defaultType,
        check: '',
        images: [],
        source: '',
        domain: [defaultDomain],
        number: 2,

    }
    //Data ist the container for the data
    const [data, setData] = useState(emptyForm);
    console.log(data)

    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleChange = (event, newValue) => {
        //console.log(event.target)
        let { value, name } = event.target;
        if (name === "check") {
            const { checked } = event.target;
            value = checked;
        }
        setData(data => {
            return {
                ...data,
                [name]: value
            };
        });
    };


    // Reset Form
    const handleResetForm = () => {
        //setData(emptyForm);
        setData(prevData => ({
            ...prevData,
            name: emptyForm.name,
            description: emptyForm.description,
            descriptionHtml: emptyForm.descriptionHtml,
            abbreviation: emptyForm.abbreviation,
            //type: emptyForm.type,
            check: emptyForm.check,
            images: emptyForm.images,
            source: emptyForm.source,
            number: emptyForm.number,
            //domain: emptyForm.domain,
        }));
        setFormSubmitted(false);
    }

    // Create the new Term
    const handleSubmit = () => {
        const { name, description, type, images, source, descriptionHtml, domain, abbreviation } = data;
        // Create the new Terms
        console.log("------------------------------");

        const myMap = new Map();

        relatedTerms.map((relTerm, index) => {
            console.log("relTerm");
            console.log(relTerm);
            if (relTerm.name !== "") {
                setFormSubmitted(false);
                const newTerm = [];
                newTerm.name = relTerm.name;
                newTerm.description = relTerm.description;
                newTerm.type = type;
                newTerm.images = [relTerm.images];
                newTerm.source = relTerm.source;
                newTerm.descriptionHtml = relTerm.description;
                newTerm.abbreviation = abbreviation;
                const d = new Date();
                let currDate = d.toISOString();
                newTerm.date = currDate;
                newTerm.domain = [domain];
                newTerm.status = "Draft";

                // Backend Communiactaion
                console.log("newTerm");
                console.log(newTerm);

                // Check if the Term is already in the List
                let stillThere = false
                termArray.map((term) => {
                    if (term.name === relTerm.name) {
                        stillThere = true
                        myMap.set(term.name, term._id);
                    }
                })

                // Create the Term
                if (!stillThere) {
                    CreateTerm(newTerm, setTermArray, contextType.token, contextType.activeGroup)
                        .then(result => {
                            console.log('Term created successfully:', result);
                            console.log('Term created successfully:', result.data.createTerm._id);
                            myMap.set(result.data.createTerm.name, result.data.createTerm._id);
                            setOpenAlert(true)
                            handleResetForm()
                        })
                        .catch(error => {
                            console.error('Error creating term:', error);
                            setOpenErrorAlert(true)
                        });
                } else {
                    setOpenErrorAlert(true)
                }

            } else {
                //console.log("New Term has not been added: Missing Name");
            }
        })

        console.log("------------- myMap --------------------");
        console.log(myMap);

        // Create the Links




        // 2. Zu jedem Term die Links erstellen
        let count = 0
        relatedTerms.map((relTerm, index) => {
            //console.log("relTerm");
            //console.log(relTerm);

            /* Object.entries(relTerm.relation).forEach(([key, value]) => {
                console.log(`Schlüssel: ${key}, Wert: ${value}`);
            }); */


            myMap.forEach((termId, termName) => {
                //console.log(`Schlüssel: ${termName}, Wert: ${termId}`);

                if (relTerm.relation.hasOwnProperty(termName)) {

                    // Erstelle einen neuen Link
                    const newLink = [];
                    newLink.fromId = myMap.get(relTerm.name)
                    newLink.toId = termId
                    newLink.type = "generisch"
                    newLink.description = relTerm.relation[termName]

                    const d = new Date();
                    let currDate = d.toISOString();
                    newLink.date = currDate;
                    newLink.name = relTerm.relation[termName]




                    // 1. Prüfen ob Link Schon existiert
                    let exist = false
                    linkArray.map((link) => {
                        if (newLink.fromId === link.source && newLink.toId === link.target || newLink.fromId === link.target && newLink.toId === link.source) {
                            console.log("Link is already in the List");
                            exist = true
                        } else {

                        }
                    })

                    // Füge den neuen Link der Dtatei hinzu
                    // Backend Communiactaion
                    CreateLink(newLink, setLinkArray, contextType.token)
                    setOpenAlert(true)

                    count++
                    console.log(" ########### newLink - " + count + " - " + termName + " - " + relTerm.name);
                    console.log(newLink);

                } else {
                    // console.log(value + "  ist nicht im Objekt vorhanden.");
                }

            });
        })
    }

    // Create the new Term
    const handleReset = () => {
        handleResetForm()
    }

    // Make Abbreviation of the Name
    const handlMakeAbbreviation = () => {
        const abb = akronim(data.name)
        setData(data => { return { ...data, "abbreviation": abb }; });
    }

    // Search Image in Google
    const handlSearchImage = () => {
        const searchQuery = data.name
        const searchUrl = `https://www.google.com/search?q=${encodeURIComponent(searchQuery)}&tbm=isch`;
        // Open a new window with the Google Image Search URL
        window.open(searchUrl, '_blank');
    }

    // Open the Source Link
    const handlOpenLinke = () => {
        window.open(data.source, '_blank');
    }

    // Search in Wiki for the related Terms
    const handlWikiSelection = async (name) => {
        const dataObject = {};
        if (name !== "") {
            try {
                wiki.setLang("de");
                const page = await wiki.page(name);
                const summary = await page.summary();
                //console.log(summary);

                // Optional: Setzen Sie die Daten in Ihrem Zustand
                // setData(data => { return { ...data, "name": name }; });
                // setData(data => { return { ...data, "description": summary.extract }; });
                // setData(data => { return { ...data, "descriptionHtml": summary.extract_html }; });
                // setData(data => { return { ...data, "source": page.fullurl }; });
                // if (summary.originalimage) {
                //     setData(data => { return { ...data, "images": summary.originalimage.source }; });
                // }

                return summary;
            } catch (error) {
                console.error("Fehler beim Abrufen der Wikipedia-Seite:", error);
                return "Err";
            }
        }
        return null;
    };


    ///////////////////////
    // TEST !!!!!!!!!!!! //
    ///////////////////////

    const handleTest = async () => {
        //const { name } = data;
        //const summary = await handlWikiSelection(name);
        //console.log("Summary:", summary.originalimage.source);

        // Verwenden Sie Promise.all, um auf alle asynchronen Operationen zu warten
        const updatedRelatedTermsList = await Promise.all(
            relatedTerms.map(async (relTerm, index) => {
                console.log("Name:", relTerm.name);

                // Warten Sie auf das Ergebnis der handlWikiSelection-Funktion
                const summary = await handlWikiSelection(relTerm.name);

                // Überprüfen Sie, ob das summary-Objekt ein originalimage enthält
                if (summary && summary.originalimage) {
                    relTerm.images = summary.originalimage.source;
                } else {
                    relTerm.images = "";
                }

                console.log("Summary:", relTerm.images);

                return relTerm;
            })
        );

        // Weisen Sie die aktualisierte Liste zu
        relatedTermsList = updatedRelatedTermsList;
    }


    ///////////////////////
    // Search in ChatGPT //
    ///////////////////////

    //const OPENAI_API_KEY = "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"

    const handlSearchGpt = () => {

        setLoading(true);
    
        const { name } = data;
        //console.log("---> andlSearchGpt");
        const number = data.number

        // Prompt for the GPT-3.5 model //
        const jsonString = `
                            [
                                {
                                    "name": "Begriff A",
                                    "description": "<p><strong>Defintion:</strong> Das ist eine Defintion</p> <p><strong>Beschreibung:</strong> Das ist eine Beschreibung</p> <p><strong>Beispiele:</strong></p><ul><li>Beispiel</li><li>Beispiel</li><li>Beispiel</li></ul>",
                                    "source": "https://...",
                                    "images": "https://...",
                                    "relation": {			
                                        "Begriff B": "Relationstype zu A",
                                        "Begriff C": "Relationstype Zu A"
                                    }
                                }
                            ]
                            `;

        const prompt = "Erstelle mir eine Tabelle mit den " + number + " wichtigsen Begriffen der folgenden Domain: " + name + "." +
            "Die Tabelle soll die folgenden Spalten haben: name, description, source, images , relation" +

            "Die Spalte 'description' sollte das folgende enthalten: eine Definition des Begriffes, eine ausführliche Beschreibung und drei Beispiele, um die Definition besser zu verstehen." +
            "Die Spalte 'relation' soll Folgendes enthalten: die wichtigsten Namen der Begriffe aus der Tabelle, die mit dem Begriff in dieser Zeile in Verbindung stehen, sowie den dazugehörigen semantischen Relationstyp (auf Deutsch)." +
            "Die Spalte 'source' sollte das folgende enthalten: nur ein Link enthalten, woher die informationen kommen." +
            "Die Spalte 'images' sollte das folgende enthalten: ein Link auf ein Bild im internet zu Beispiel wikimedia. Suche nach einem passenden Bild für den Begriff aus der Zeile und gib mir die URL des Bildes zurück. Prüfe dabei ob die URL auch wirklich ein bild enthält" +

            "Die Domain soll zusätzlich auch als Begriff mit in der Tabelle ganz oben stehen. " +
            "Als antwort muss die Tabelle in form eines JSON sein. Sie sollte so aussehen wie in dem folgenden Beispiel: " + jsonString + ""



        const dataObject = {};
        if (name !== "") {
            (async () => {
                try {

                    //console.log("---> prompt");
                    //console.log(prompt);

                    //console.log("-------------------------------------------------------------------");
                    const response = await fetch("https://api.openai.com/v1/chat/completions", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${OPENAI_API_KEY}`,
                        },
                        body: JSON.stringify({
                            model: "gpt-3.5-turbo", // Oder gpt-3.5-turbo
                            messages: [{ role: "user", content: prompt }],
                        }),
                    });

                    const data = await response.json();
                    let content = data.choices[0].message.content
                    /* console.log("data.choices[0].message.content");
                    console.log(data.choices[0].message.content);
                    console.log("data");
                    console.log(data); */

                    //setData(data => { return { ...data, "description": content }; });
                    //console.log("-------------------------------------------------------------------");
                    //console.log("content");
                    //console.log(content);

                    // Entfernen von führenden und nachfolgenden Leerzeichen
                    content = content.replace("```json", "").replace("```", "").trim();
                    content = content.trim();

                    // JSON-String in ein Objekt umwandeln
                    //let jsonObject = {}
                    try {
                        const jsonObject = JSON.parse(content);
                        //console.log("jsonObject");
                        //console.log(jsonObject);
                        // Ausgabe: [{ name: 'Demokratie', description: '...', source: '...', images: '...', Relation: [...] }]


                        if (jsonObject.length != 0) {
                            // Suche bei wikipedia nach den Begriffen und einem Passendem Bild
                            const updatedRelatedTermsList = await Promise.all(
                                jsonObject.map(async (relTerm, index) => {
                                    //console.log("Name:", relTerm.name);

                                    // Warten Sie auf das Ergebnis der handlWikiSelection-Funktion
                                    const summary = await handlWikiSelection(relTerm.name);

                                    // Überprüfen Sie, ob das summary-Objekt ein originalimage enthält
                                    if (summary && summary.originalimage) {
                                        relTerm.images = summary.originalimage.source;
                                    } else {
                                        relTerm.images = "";
                                    }

                                    //console.log("Summary:", relTerm.images);

                                    return relTerm;
                                })
                            );

                            // Weisen Sie die aktualisierte Liste zu                   
                            setRelatedTerms(updatedRelatedTermsList)
                            setLoading(false);                           
                        }

                    } catch (error) {
                        console.error("Fehler beim Parsen des JSON-Strings:", error);
                        setLoading(false);                        
                    }

                } catch (error) {
                    console.log(error); 
                    setLoading(false);                                  
                }
            })()
        } else {
            //console.log("Name ist empty");
        }
    }


    ///////////
    // Table //
    ///////////

    // Generate Rows of each Table base on the setting name
    const tableRows = () => {
        if (relatedTerms.length > 0) {

            const li = relatedTerms.map((relTerm, index) => {

                if (relTerm.name != "") {

                    // Parameter
                    let showIcon = false
                    let radioButtonSelected = false
                    const key = `listItems-${index}`;

                    // Click on item Function
                    const itemClickFunction = () => {
                        setItemSelected(index)
                    }

                    // Click on item Button Function
                    const itemClickUseButton = () => {
                        setItemSelected(index)
                        radioButtonSelected = true
                        //handlWikiSelection(name)
                    }

                    // Ceck if the Term is already in the List
                    termArray.map((term) => {
                        if (term.name === relTerm.name) {
                            showIcon = true
                        }
                    })

                    // Edible Columbs
                    let p0 = relTerm.name
                    let p1 = parse(relTerm.description)

                    // Create the HTML String for the Links
                    let hstmStirng = "<p><strong>Link to:</strong></p>" + "<ul>"
                    Object.keys(relTerm.relation).map((rel) => {
                        //console.log("rel");
                        hstmStirng = hstmStirng + "<li>" + rel + " - " + relTerm.relation[rel] + "</li>"
                    })
                    hstmStirng = hstmStirng + "</ul>"
                    hstmStirng = hstmStirng + "<p><strong>Quelle</strong>:<a href=\"" + relTerm.source + "\">" + relTerm.source + "</a></p>" +
                        "<p><strong>Bild</strong>:<a href=\"" + relTerm.images + "\">" + relTerm.images + "</a></p>";
                    let p2 = parse(hstmStirng)

                    // Create the HTML String for the Image
                    let p3 = parse("<p><img src=\"" + relTerm.images + "\" alt=\"No Image found\" width=\"200\" style=\"border-radius: 8px;\" /></p>");
                    const handleChangeTabelItem = (event) => {
                        //console.log(event.target.name)
                        if (event.target.name === "parameter") {
                            p0 = event.target.value;
                        }
                        if (event.target.name === "description") {
                            p1 = event.target.value;
                        }
                        //setFlag(false)
                    };

                    // Return Table Items
                    return (
                        <TableRow key={relTerm.name + "_" + p0 + "_" + p1 + "_" + Math.random()}>
                            <StyledTableCell component="th" scope="row" style={{ verticalAlign: "center", textAlign: "center" }}>

                                {showIcon && (
                                    <TooltipStyle title={"This Term is still in your List"} arrow>
                                        <IconButton
                                            className={classes.fab}
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            aria-label="radio button"
                                            size="small"
                                            onClick={itemClickUseButton}
                                        >
                                            <CheckCircleIcon />
                                        </IconButton>
                                    </TooltipStyle>
                                )}
                                {!showIcon && (
                                    <TooltipStyle title={"Click here an will happen nothing :-)"} arrow>
                                        <IconButton
                                            className={classes.fab}
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            aria-label="radio button"
                                            size="small"
                                            onClick={itemClickUseButton}
                                        >
                                            {itemSelected === index && <RadioButtonCheckedIcon />}
                                            {itemSelected != index && <RadioButtonUncheckedIcon />}
                                        </IconButton>
                                    </TooltipStyle>
                                )}
                            </StyledTableCell>

                            <StyledTableCell component="th" scope="row" style={{ verticalAlign: "center", textAlign: "left" }}>
                                {p0}
                            </StyledTableCell >
                            <StyledTableCell align="left">
                                {p1}
                            </StyledTableCell >
                            <StyledTableCell align="left">
                                {p2}
                            </StyledTableCell >
                            <StyledTableCell align="center" >
                                {p3}
                            </StyledTableCell >
                        </TableRow>
                    )
                }
            })
            return li;
        }
    }

    // Table Conatiner for each Setting inklude New button
    const generateSettingTable = (settingName) => {
        return (
            <>
                <TableContainer className={classes.table} component={Paper}>
                    <Table  size="small" aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="right">Exist</StyledTableCell>
                                <StyledTableCell align="left">Name</StyledTableCell>
                                <StyledTableCell align="left">Description</StyledTableCell>
                                <StyledTableCell align="left">Links</StyledTableCell>
                                <StyledTableCell align="center">Picture</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tableRows()} 
                        </TableBody>
                    </Table>
                </TableContainer>
            </>
        )
    }


    ///////////////////////////////////////////
    // Create Listitems of all related Terms //
    ///////////////////////////////////////////

    let relatedTermsList = []

    //console.log("relatedTerms")
    //console.log(relatedTerms)
    if (Object.keys(relatedTerms).length > 0) {


        relatedTermsList = relatedTerms.map((relTerm, index) => {

            // Parameter
            let description = ""
            let showIcon = false
            let radioButtonSelected = false
            const key = `listItems-${index}`;

            // Get the description of the related Term
            /*  if (relatedTerms.hasOwnProperty(name)) {
                 description = relatedTerms[name].description
             } */


            // Click on item Function
            const itemClickFunction = () => {
                setItemSelected(index)
            }

            // Click on item Button Function
            const itemClickUseButton = () => {
                setItemSelected(index)
                radioButtonSelected = true
                //handlWikiSelection(name)
            }

            // Ceck if the Term is already in the List
            termArray.map((term) => {
                if (term.name === relTerm.name) {
                    showIcon = true
                }
            })

            //console.log("name");
            //console.log(relTerm.name);
            //console.log("description");
            //console.log(relTerm.description);

            // Create the HTML String
            let hstmStirng = "<p><strong>Link to:</strong></p>" + "<ul>"
            Object.keys(relTerm.relation).map((rel) => {
                //console.log("rel");
                hstmStirng = hstmStirng + "<li>" + rel + " - " + relTerm.relation[rel] + "</li>"
            })
            hstmStirng = hstmStirng + "</ul>"

            hstmStirng = hstmStirng + "<p><strong>Quelle</strong>:<a href=\"" + relTerm.source + "\">" + relTerm.source + "</a></p>" +
                "<p><strong>Bild</strong>:<a href=\"" + relTerm.images + "\">" + relTerm.images + "</a></p>" +
                "<p><img src=\"" + relTerm.images + "\" alt=\"No Image found\" width=\"200\" /></p>";




            // Combine the Description with the HTML String
            let secondaryCellContent = relTerm.description + " " + hstmStirng
            //console.log("secondaryCellContent");
            //console.log(secondaryCellContent);

            return (
                <>
                    <ListItem className={classes.listItem} key={key} selected={itemSelected === index}>
                        {showIcon && (
                            <TooltipStyle title={"This Term is still in your List"} arrow>
                                <IconButton
                                    className={classes.fab}
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    aria-label="radio button"
                                    size="small"
                                    onClick={itemClickUseButton}
                                >
                                    <CheckCircleIcon />
                                </IconButton>
                            </TooltipStyle>
                        )}
                        {!showIcon && (
                            <TooltipStyle title={"Click here an will happen nothing :-)"} arrow>
                                <IconButton
                                    className={classes.fab}
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    aria-label="radio button"
                                    size="small"
                                    onClick={itemClickUseButton}
                                >
                                    {itemSelected === index && <RadioButtonCheckedIcon />}
                                    {itemSelected != index && <RadioButtonUncheckedIcon />}

                                </IconButton>
                            </TooltipStyle>
                        )}
                        <ListItemText
                            className={classes.listTextItem}
                            primary={relTerm.name}                            
                            secondary={relTerm.description != "" && parse(secondaryCellContent)}
                        />
                        {/* <ListItemSecondaryAction>
                            {parse("<p><img src=\"" + relTerm.images + "\" alt=\"No Image found\" width=\"200\" /></p>")}
                        </ListItemSecondaryAction> */}
                    </ListItem>
                    <Divider className={classes.divider} />
                </>
            )

        });
    }


    //////////////
    // Snackbar //
    //////////////

    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false)
    }

    const handleCloseErrorAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenErrorAlert(false)
    }

    const handleEmptySearachCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenEmptySearachAlert(false)
    }

    /////////////////
    // Main Return //
    /////////////////
    return (
        <>
            <Grid container spacing={3} className={classes.gridContainer}>
                <Grid item xs={12} sm={12} style={{ height: '100%' }}>
                    <Paper className={classes.paper}>
                        <Box className={classes.flexContainer}>
                            <Typography className={classes.text} variant="h6">Create a new Domain</Typography>
                            <TooltipStyle title={"Reset the current content"} arrow>
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleReset}
                                    edge="end"
                                    size="small"
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </TooltipStyle>
                        </Box>
                        <div>
                            <NameInput data={data} onChange={handleChange} classes={classes} name={"name"} />
                            <SelectTermDomainSpace data={data} onChange={handleChange} classes={classes} domainSpaceDefinition={domainSpaceDefinition} />

                            <TextField
                                name={"number"}
                                value={data.number}
                                onChange={event => handleChange(event, data.number)}
                                id="standard-basic"
                                label={"Number"}
                                className={clsx(classes.input, classes.margin)}
                                variant="outlined"
                                size="small"
                            />
                            <ButtonGroup variant="contained" color="primary" aria-label="outlined primary button group" className={classes.button}>
                                <TooltipStyle title={"Create based on the defined Domain related Terms"} arrow>
                                    {/* <Button color="primary" onClick={handlSearchGpt} startIcon={<AssistantIcon />}>Create</Button> */}
                                    <Button color="primary" onClick={handlSearchGpt} startIcon={<BlurOnIcon />}>Generate</Button>
                                </TooltipStyle>
                            </ButtonGroup>

                             {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                                               

                            <Box className={classes.table}>
                                {generateSettingTable}
                            </Box>

                            <Divider className={classes.dividerTop} />
                            <Box className={classes.list}>
                                <List>{relatedTermsList}</List>
                            </Box>
                            <Divider className={classes.dividerBottom} />

                        </div>

                        <div>
                            <Button variant="contained" color="primary" onClick={handleSubmit} className={classes.button}>Add to list</Button>
                            {/* <Button variant="contained" color="primary" onClick={handleTest} className={classes.button}>Test</Button> */}

                        </div>

                    </Paper>

                </Grid>
            </Grid>

            <SnackBarError open={openEmptySearachAlert} handleClose={handleEmptySearachCloseAlert} message="There was nothing found on Wiki!" />
            <SnackBarSuccess open={openAlert} handleClose={handleCloseAlert} message="New Term and Link has bin added!" />
            <SnackBarError open={openErrorAlert} handleClose={handleCloseErrorAlert} message="New Term has not bin added!" />

        </>
    )
}